import React, { useCallback, useEffect, useRef, useState } from "react";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import "./anaSayfa.css";

/**
 * Yatay kaydırmalı şerit: içerik sığmazsa kenarlarda yuvarlak ok çıkar (header kategorileri ve kart listelerindeki gibi),
 * telefonda parmakla da kaydırılır. Öğeler yan yana kalır, alt alta inmez.
 */
export default function KaydirmaSeridi({ children, className = "" }) {
    const serit = useRef(null);
    const [sol, setSol] = useState(false);
    const [sag, setSag] = useState(false);

    const okDurumu = useCallback(() => {
        const s = serit.current;
        if (!s) return;
        setSol(s.scrollLeft > 4);
        setSag(s.scrollLeft + s.clientWidth < s.scrollWidth - 4);
    }, []);

    useEffect(() => {
        okDurumu();
        window.addEventListener("resize", okDurumu);
        return () => window.removeEventListener("resize", okDurumu);
    }, [okDurumu, children]);

    const kaydir = (yon) => {
        const s = serit.current;
        if (s) s.scrollBy({ left: yon * Math.max(200, s.clientWidth * 0.7), behavior: "smooth" });
    };

    return (
        <div className="iu-serit-cerceve">
            {sol && <button className="iu-serit-ok iu-serit-ok-sol" onClick={() => kaydir(-1)} aria-label="Sola kaydır"><ChevronLeftIcon /></button>}
            <div className={"iu-serit " + className} ref={serit} onScroll={okDurumu}>
                {children}
            </div>
            {sag && <button className="iu-serit-ok iu-serit-ok-sag" onClick={() => kaydir(1)} aria-label="Sağa kaydır"><ChevronRightIcon /></button>}
        </div>
    );
}
